import { Component, Input } from '@angular/core';
import { SLEntity } from '../entity';

@Component({
  selector: 'sl-entity-details',
  templateUrl: './entity-details.component.html',
})
export class SLEntityDetailsComponent {

  @Input()
  entity: SLEntity
}
